import React from 'react';
import { Range } from 'react-date-range';
import { SlidersHorizontal, X } from "lucide-react";
import { CommonSelect } from "./CommonSelect";
import DateRangePicker from "./DateRange";

interface FilterBarProps {
    activeFilter: string;
    setActiveFilter: (v: any) => void;
    customDateRange: Range[];
    setCustomDateRange: (v: Range[]) => void;
    selectedStoreId: string;
    setSelectedStoreId: (v: string) => void;
    selectedStatus: string;
    setSelectedStatus: (v: string) => void;
    stores: { id: string; name: string }[];
}

export const FilterBar: React.FC<FilterBarProps> = ({
    activeFilter,
    setActiveFilter,
    customDateRange,
    setCustomDateRange,
    selectedStoreId,
    setSelectedStoreId,
    selectedStatus,
    setSelectedStatus,
    stores,
}) => {
    const hasFilters = activeFilter !== '' || selectedStoreId !== '' || selectedStatus !== '';

    const handleClearFilters = () => {
        setActiveFilter('');
        setSelectedStoreId('');
        setSelectedStatus('');
        setCustomDateRange([{
            startDate: new Date(), endDate: new Date(), key: 'selection'
        }]);
    };

    return (
        <div className="flex flex-wrap items-center gap-3 p-4 bg-card border rounded-xl shadow-sm">
            <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground mr-1">
                <SlidersHorizontal className="w-4 h-4 text-primary" />
                <span>Filters:</span>
            </div>

            {/* Time Range Filter */}
            <CommonSelect
                value={activeFilter}
                onValueChange={setActiveFilter}
                placeholder="Select Time Range"
                options={[
                    { value: 'today', label: 'Today' },
                    { value: 'weekly', label: 'This Week' },
                    { value: 'monthly', label: 'This Month' },
                    { value: 'yearly', label: 'This Year' },
                    { value: 'custom', label: 'Custom Range' },
                ]}
            />

            {/* Dynamic Stores Filter */}
            {/* <CommonSelect
                value={selectedStoreId}
                onValueChange={setSelectedStoreId}
                placeholder="Select Store"
                options={[
                    // { value: '', label: 'All Stores' },
                    ...stores.map(storeData => ({ value: storeData.id, label: storeData.name }))
                ]}
            /> */}

            {/* Status Filter */}
            {/* <CommonSelect
                value={selectedStatus}
                onValueChange={setSelectedStatus}
                placeholder="All Statuses"
                options={[
                    { value: '', label: 'All Statuses' },
                    { value: 'pending', label: 'Pending' },
                    { value: 'accepted', label: 'Accepted' },
                    { value: 'in_progress', label: 'Preparing' },
                    { value: 'ready_for_pickup', label: 'Ready' },
                    { value: 'out_for_delivery', label: 'Out for Delivery' },
                    { value: 'delivered', label: 'Delivered' },
                    { value: 'completed', label: 'Completed' },
                    { value: 'cancelled', label: 'Cancelled' },
                    { value: 'failed', label: 'Failed' },
                    { value: 'delayed', label: 'Delayed' },
                    { value: 'refund_requested', label: 'Refund Requested' },
                    { value: 'refunded', label: 'Refunded' },
                ]}
            /> */}

            {/* Custom Date Range Picker */}
            {activeFilter === 'custom' && (
                <div className="animate-in slide-in-from-right-2 duration-200">
                    <DateRangePicker dateRange={customDateRange} setDateRange={setCustomDateRange} />
                </div>
            )}

            {/* Clear Filters Button */}
            {hasFilters && (
                <button
                    onClick={handleClearFilters}
                    className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-destructive hover:bg-destructive/10 rounded-md transition-colors ml-auto border border-transparent hover:border-destructive/10 cursor-pointer"
                >
                    <X className="w-4 h-4" />
                    Clear Filters
                </button>
            )}
        </div>
    );
};